import {MovementExceptionTypeCd} from '../';
import {EnumHelper} from './enum-helper';

export class MovementExceptionTypeCdHelperEnumHelperClass extends EnumHelper {

  public constructor() {
  	super();
    for ( const obj in MovementExceptionTypeCd ) {
      this._values.push(MovementExceptionTypeCd[obj]);
      this._keys.push(obj);
    }
  }

  public toEnum(value: string): MovementExceptionTypeCd {

    for ( const obj in MovementExceptionTypeCd ) {
      if (MovementExceptionTypeCd[obj] === value){
        return MovementExceptionTypeCd[obj] as MovementExceptionTypeCd;
      }
    }
  }
}

const MovementExceptionTypeCdHelper = new MovementExceptionTypeCdHelperEnumHelperClass();
export default MovementExceptionTypeCdHelper;
